import React from 'react';

import { FieldProps } from 'formik';
import DatePicker from 'react-datepicker';
import { FormFeedback, FormGroup, Label } from 'reactstrap';
import DashboardSvgIcon from '../../../Utils/CommonComponents/DashboardSvgIcon';

interface Props {
   name: string;
   label?: string;
   placeholder?: string;
   className?: string;
   required?: boolean;
   minDate?: Date;
}

export const CustomDatePiker: React.FC<Props & FieldProps> = ({
   field,
   form,
   name,
   label,
   placeholder = 'Select a date',
   className = 'form-control',
   required = false,
   minDate,
}) => {
   const isInvalid = !!(
      form.touched?.[field.name] && form.errors?.[field.name]
   );

   const handleChange = (date: Date | null) => {
      form.setFieldValue(field.name, date);
   };

   return (
      <FormGroup>
         <Label
            for={name}
            style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
         >
            {label}
            {required && <a> *</a>}
         </Label>
         <DatePicker
            id={name}
            name={name}
            className={className}
            selected={field.value}
            onChange={handleChange}
            placeholderText={placeholder}
            showIcon
            required={required}
            icon={<i className="fa-solid fa-calendar-days mt-1"></i>}
            minDate={minDate}
         />
         {isInvalid && (
            <FormFeedback className="d-block">
               {(form.errors?.[field.name] as string) || 'Error inesperado'}
            </FormFeedback>
         )}
      </FormGroup>
   );
};
